import { useCallback } from 'react';
import { useMutation } from '@apollo/client/react';
import { toastErrorMessage } from 'utils/helpers';
import { AdjustExpressLoanSettingsDocument } from 'graphql/generated/graphql';

const useAdjustExpressLoanSettings = () => {
  const [adjustExpressLoanSettings] = useMutation(AdjustExpressLoanSettingsDocument);

  const handleSubmit = useCallback(
    async (formData: { total_account_fees: number; execution_fee: number }) => {
      try {
        await adjustExpressLoanSettings({ variables: { formData } });
      } catch (error) {
        toastErrorMessage(error);
      }
    },
    [adjustExpressLoanSettings],
  );
  return handleSubmit;
};

export default useAdjustExpressLoanSettings;
